import StationDetail from './StationDetail';

export default StationDetail;



// WEBPACK FOOTER //
// ./src/containers/site-visits/stationDetail/index.js